//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            // 客服头像
            notificationShow: false,
            notiInfo: {}, // 消息
            csrPhoto: './static/images/csr_photo.png'
            // messageTipVoice: new Audio('./static/messageTip.mp3')
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        notification() {
            return this.$store.state.notification;
        }
    },
    watch: {
        notificationShow(val) {
            if (val) {
                setTimeout(() => {
                    this.notificationShow = false;
                }, 3000);
            }
        },
        notification(newVal) {
            if (!this.$isPc()) {
                let dom = document.getElementById('audio');
                dom.play();
                this.notiInfo = newVal;
                this.notificationShow = true;
            }
        },
        $route(to, from) {
            console.log(to.path);
            if (to.path == '/customer') {
                this.notificationShow = false;
            }
        },
        userInfo: {
            handler(userInfo) {
                if (userInfo && userInfo.accountId) {
                    var userUnreadInfo = [];
                    if (localStorage.getItem('unreadInfo')) {
                        userUnreadInfo = JSON.parse(localStorage.getItem('unreadInfo'));
                    }
                    for (let index = 0; index < userUnreadInfo.length; index++) {
                        if (userUnreadInfo[index].accountId === userInfo.accountId) {
                            this.$store.state.unreadMessageNum = userUnreadInfo[index].unreadMessageNum || 0;
                        }
                    }
                } else {
                    this.$store.state.unreadMessageNum = 0;
                }
            },
            deep: true
        }
    },
    methods: {
        // 时间戳格式化
        timestampToTime(value) {
            if (value && value != '0') {
                return this.$moment(value * 1000).format('HH:mm');
            }
        },
        // 客服聊天也
        toCsrPage() {
            this.$router.push('/customer?backPath=' + this.$route.path);
            this.notificationShow = false;
        },
        // 收到消息， 弹出提示框
        popupNotification(obj) {
            this.$emit('popupNotification');
        },
        /**
         * @description:  富文本提取纯文本展示
         * @param {type}
         * @return:
         */
        richTextTransferText(richText_) {
            if (richText_) {
                richText_ = richText_.replace(/(<img[^>]*>)/g, '[图片]');
                richText_ = richText_.replace(/(\n)/g, '');
                richText_ = richText_.replace(/(\t)/g, '');
                richText_ = richText_.replace(/(\r)/g, '');
                richText_ = richText_.replace(/<\/?[^>]*>/g, '');
                richText_ = richText_.replace(/\s*/g, '');
                return richText_;
            } else {
                return ' ';
            }
        }
    },
    mounted() {
        this.$store.state.Notification = this;
        this.$refs.audio.src = './static/messageTip.mp3';
    }
};



// WEBPACK FOOTER //
// ./src/components/customerService/notification.vue